// removed by extract-text-webpack-plugin
module.exports = {"normalize":"BidButton-normalize","colourOrange":"BidButton-colourOrange","colourBlue":"BidButton-colourBlue","colourGreen":"BidButton-colourGreen","colourRed":"BidButton-colourRed","colourGrey":"BidButton-colourGrey"};


//////////////////
// WEBPACK FOOTER
// ./src/components/BidButton/index.css
// module id = 1702
// module chunks = 0